import type { UserResultDTO } from '@nora-monorepo/nora-api-client';

export function getInitials(user: UserResultDTO | string): string {
  let initials = '';

  // If name is set split by spaces and use the first letter of the first two words
  const splitAndGetInitials = (name: string): string => {
    const nameParts = name.split(' ');
    if (nameParts.length === 1) {
      const firstName = nameParts[0] ?? '';
      return firstName.substring(0, 2).toUpperCase();
    }
    else {
      const firstName = nameParts[0] ?? '';
      const secondName = nameParts[1] ?? '';
      const firstInitial = firstName[0]?.toUpperCase() ?? '';
      const secondInitial = secondName[0]?.toUpperCase() ?? '';
      return `${firstInitial}${secondInitial}`;
    }
  };

  if (typeof user === 'string') {
    initials = splitAndGetInitials(user);
  }
  else if (user.customCallSign) {
    initials = splitAndGetInitials(user.customCallSign);
  }
  else if (user.callSign) {
    initials = splitAndGetInitials(user.callSign);
  }
  else if (user.firstName && user.lastName) {
    const firstInitial = user.firstName[0]?.toUpperCase() ?? '';
    const lastInitial = user.lastName[0]?.toUpperCase() ?? '';
    initials = `${firstInitial}${lastInitial}`;
  }
  else if (user.username) {
    initials = splitAndGetInitials(user.username);
  }

  return initials;
}
